// src/components/plan/WaitingPeriodsTab.js
import React from 'react'

function WaitingPeriodsTab({ plan }) {
  const waitingPeriods = plan?.waiting_periods || {}

  return (
    <div>
      <h4 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>⏳ Waiting Periods</h4>
      {Object.keys(waitingPeriods).length > 0 ? (
        <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
          {Object.entries(waitingPeriods).map(([key, value]) => (
            <li key={key} style={{ marginBottom: '0.5rem' }}>
              <strong>{key.replace(/_/g, ' ')}:</strong> {value || '—'}
            </li>
          ))}
        </ul>
      ) : (
        <p>None</p>
      )}
    </div>
  )
}

export default WaitingPeriodsTab
